/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fw_Bm_Kind_LeadInputs */

const en_fw_bm_kind_lead = /** @type {(inputs: Fw_Bm_Kind_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Which kind of acceptance criterion an agent clears first time — and where.`)
};

const id_fw_bm_kind_lead = /** @type {(inputs: Fw_Bm_Kind_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jenis kriteria penerimaan mana yang lolos sekali jalan — dan di lapisan mana.`)
};

/**
* | output |
* | --- |
* | "Which kind of acceptance criterion an agent clears first time — and where." |
*
* @param {Fw_Bm_Kind_LeadInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const fw_bm_kind_lead = /** @type {((inputs?: Fw_Bm_Kind_LeadInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fw_Bm_Kind_LeadInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_fw_bm_kind_lead(inputs)
	return en_fw_bm_kind_lead(inputs)
});